import { ReceiptType } from '../typegen/receipt-type';

const paths = {
	kiosksAuth: '/kiosks/auth',
	kiosksPostSession: '/kiosks/post-session',
	lookupAccountNumber: '/lookups/account-number',
	lookupAddressLastName: '/lookups/address-lastname',
	lookupPhoneLastName: '/lookups/phone-lastname',
	lookupTransactionId: '/lookups/transaction-id',
	lookupTest: '/lookups/test',
	prepareTransaction: '/payments/prepare-transaction',
	paymentCreditCardPayments: '/payments/magtek-data',
	paymentTokenPayments: '/payments/token',
	paymentCashPayments: '/payments/cash',
	paymentCheckPayments: '/payments/check',
	paymentTest: '/payments/test',
	paymentManagerEmvTest: '/payments/manager-emv-test',
	paymentManagerEmvTestConfigs: '/payments/manager-emv-test/configs',
	appLogsUpload: '/applogs/upload',
	cashBoxTotals: '/cashbox/totals',
	cashBoxRemove: '/cashbox/remove',
	cashBoxLastInsertTime: '/cashbox/last-insert-time',
	test: '/test',
	isServiceAvailable: '/kiosks/is-service-available',

	get legacyBpkAdminPostAlert() {
		return import.meta.env.VITE_LEGACY_BPK_API_BASE_URL + '/api/V2.0/KioskAlerts/postAlert';
	},
	get legacyBpkAdminPostKioskSession() {
		return import.meta.env.VITE_LEGACY_BPK_API_BASE_URL + '/api/V2.0/KioskUserSessions/postSession';
	},
	get legacyBpkAdminPostNavSession() {
		return import.meta.env.VITE_LEGACY_BPK_API_BASE_URL + '/api/V2.0/NavURL/postNavURL';
	},
	get legacyBpkAdminPostCashBoxRemoved() {
		return import.meta.env.VITE_LEGACY_BPK_API_BASE_URL + '/api/V2.0/KioskCashRemover/cashBoxRemoved';
	},
	get legacyBpkAdminGetIsMaintenanceModeOn() {
		return import.meta.env.VITE_LEGACY_BPK_API_BASE_URL + '/api/V2.0/KioskConfiguration/getMaintenance';
	},
	get legacyBpkAdminGetIsApiActive() {
		return import.meta.env.VITE_LEGACY_BPK_API_BASE_URL + '/api/V1.0/Ping/servicePing';
	},
	get legacyBpkAdminPostAcceptedPayment() {
		return import.meta.env.VITE_LEGACY_BPK_API_BASE_URL + '/api/V2.0/Payment/postAcceptedPayment';
	},
	get legacyBpkAdminPostAcceptedPaymentWithPaymentReference() {
		return import.meta.env.VITE_LEGACY_BPK_API_BASE_URL + '/api/V2.0/Payment/rbpkPostAcceptedPayment';
	},
	get legacyBpkAdminPostRejectedPayment() {
		return import.meta.env.VITE_LEGACY_BPK_API_BASE_URL + '/api/V2.0/Payment/postRejectedPayment';
	},
	get legacyBpkAdminPostDigitalReceipt() {
		return import.meta.env.VITE_LEGACY_BPK_API_BASE_URL + '/api/V2.0/Payment/postEmail';
	},
	get legacyBpkAdminGetUserList() {
		return import.meta.env.VITE_LEGACY_BPK_API_BASE_URL + '/api/V2.0/KioskAdminUser/getUserList';
	},
	get legacyBpkAdminCheckPin() {
		return import.meta.env.VITE_LEGACY_BPK_API_BASE_URL + '/api/V2.0/KioskAdminUser/checkPin';
	},

	getConfigPath: (kioskId: number, version: number) => `/configs/${kioskId}/v${version}`,
	getTranslationsPath: (kioskId: number, language: string) => `/translations/${kioskId}/${language}`,
	getAutoTranslatePath: (toLang: string, fromLang: string) => `/translations/auto?to=${toLang}&from=${fromLang}`,
	getDigitalReceiptPath: (receiptType: ReceiptType) => `/receipt/${receiptType}/send`,
};

export default paths;
